import { loadStripe } from '@stripe/stripe-js'
import { useMutation } from '@tanstack/react-query'
import { useAuth } from '@/contexts/auth'

// Initialize Stripe - you'd get this from env vars
const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY!)

interface CheckoutParams {
  priceId: string
  successUrl?: string
  cancelUrl?: string
}

export function useStripeCheckout() {
  const { user } = useAuth()

  return useMutation({
    mutationFn: async (params: CheckoutParams) => {
      if (!user?.email) throw new Error('User not authenticated')

      const stripe = await stripePromise
      if (!stripe) throw new Error('Stripe not loaded')

      // Redirect directly to Stripe Checkout
      const { error } = await stripe.redirectToCheckout({
        lineItems: [
          {
            price: params.priceId,
            quantity: 1,
          },
        ],
        mode: 'subscription',
        successUrl: params.successUrl || `${window.location.origin}/dashboard/billing?success=true`,
        cancelUrl: params.cancelUrl || `${window.location.origin}/dashboard/billing?canceled=true`,
        customerEmail: user.email,
        clientReferenceId: user.id, // Para identificar o usuário no webhook
      })

      if (error) {
        throw new Error(error.message)
      }
    },
  })
}
